import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CompaniaPaqueteService } from 'src/app/api/services/company-package.service';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import { CompanyPackage } from 'src/app/shared/model/package';
import { ToastService } from 'src/app/shared/service/toast.service';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { NavButtonComponent } from 'src/app/shared/component/nav-button/nav-button.component';

@Component({
  selector: 'app-package-company-admin',
  imports: [
    TableGenericComponent,
    CommonModule,
    LoadingComponent,
    LoadingComponent,
    LoadingButtonComponent,
    NavButtonComponent,
  ],
  templateUrl: './package-company-admin.component.html',
  styles: ``,
})
export class PackageCompanyAdminComponent implements OnInit {
  companyId!: string;
  packages: CompanyPackage[] = [];
  isLoading: boolean = false;
  isLoadingActivate: boolean = false;
  showModal: boolean = false;
  selectedPackage?: CompanyPackage;

  page: number = 1;
  pageSize: number = 10;
  total: number = 0;

  columns = [
    { header: 'Nombre Paquete', field: 'package.name' },
    { header: 'Usados', field: 'usedPosts' },
    { header: 'Restantes', field: 'remainingPosts' },
  ];

  constructor(
    private route: ActivatedRoute,
    private cpService: CompaniaPaqueteService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.companyId = this.route.snapshot.paramMap.get('id')!;
    this.loadPackages();
  }

  loadPackages(): void {
    this.isLoading = true;
    this.cpService.getActivesByIdCompany(this.companyId).subscribe({
      next: (res) => {
        this.packages = res.dto?.packages || [];
        this.total = this.packages.length;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
  }

  openActivateModal(pkg: CompanyPackage): void {
    this.selectedPackage = pkg;
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.selectedPackage = undefined;
  }

  confirmActivate(): void {
    if (!this.selectedPackage) return;

    this.isLoadingActivate = true;
    this.cpService.activate(this.selectedPackage.idCompanyPackage).subscribe({
      next: () => {
        this.toastService.showMessages('success', [
          'Paquete activado correctamente',
        ]);
        this.isLoadingActivate = false;
        this.showModal = false;
        this.loadPackages();
      },
      error: (err) => {
        this.toastService.showMessages(
          'error',
          err.error?.listMessage || ['No se pudo activar el paquete']
        );
        this.isLoadingActivate = false;
        this.showModal = false;
      },
    });
  }
}
